import util from './util.js'
const excel = {}

/**
 * @description 下载获取excel文件模版
 * @param {String} vm 调用页面的this
 * @param {Array} theads 表头名
 * @param {Array} filterVal 导出的表头字段名
 * @param {String} excelName 导出文件的文件名
 */
excel.downloadExcel = function(vm,theads,filterVal,excelName){
  vm.$confirm('此操作将下载excel模版文件, 是否继续?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    require.ensure([], () => {
      const {export_json_to_excel} = require('@/excel/Export2Excel'); //这里必须使用绝对路径
      const list =[]
      const data = excel.formatJson(filterVal, list);
      export_json_to_excel(theads, data, excelName);// 导出的表格名称，根据需要自己命名
    })
  }).catch(() => {
  });
}

/**
 * @description 直接从接口获取全部数据，以excel文件存储
 * @param {String} vm 调用页面的this
 * @param {String} url 获取数据的接口名
 * @param {Array} tHeader 导出的表头名
 * @param {Array} filterVal 导出的表头字段名
 * @param {Array} filtArray 需要过滤的表头字段名
 * @param {String} excelName 导出文件的文件名
 */
excel.outExecl=function(vm,url,tHeader,filterVal,filtArray,excelName,params){
  vm.$confirm('此操作将导出excel文件, 是否继续?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    vm.$axios.post(url, params).then(data => {
      const excelData = data.RespMap.list.list //你要导出的数据list。
      this.export2Excel(excelData,tHeader,filterVal,filtArray,excelName)
    })
  }).catch(() => {
  });
}
/**
 * @description 已有数据以excel文件存储（不发接口）
 * @param {Object} excelData 打印的数据
 * @param {Array} tHeader 导出的表头名
 * @param {Array} filterVal 导出的表头字段名
 * @param {Array} filtArray 需要过滤的表头字段名
 * @param {String} excelName 导出文件的文件名
 */
excel.export2Excel=function(excelData,tHeader,filterVal,filtArray,excelName){
  require.ensure([], () => {
    const {export_json_to_excel} = require('@/excel/Export2Excel'); //这里必须使用绝对路径
    const list = excelData;
    this.dateFiter(list,filtArray);
    const data = excel.formatJson(filterVal, list);
    export_json_to_excel(tHeader, data, excelName);// 导出的表格名称，根据需要自己命名
  })
}
excel.formatJson=function(filterVal, jsonData) {
  return jsonData.map(v => filterVal.map(j => v[j]))
}

excel.dateFiter = function(excelData,filtArray){
  excelData.forEach((element,index)=>{
    filtArray.forEach((ele,i)=>{
      if(ele=='state'){
        excelData[index][filtArray[i]]= util.demandState(element[filtArray[i]]);
      }else if(ele=='goodsName'){
        excelData[index][filtArray[i]]= util.changeGoodsName(element[filtArray[i]]);
      }
    });
  });
}

export default excel
